<template>
    <div>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h3>Info Teks</h3>
              <div class="card">
                <div class="card-body">
                  <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating">Info Teks</label>
                          <input type="text" class="form-control" placeholder="Info..." v-model="data.wa">
                        </div>
                        <div class="form-group">
                          <button class="btn btn-success mb-2" @click="update.submit()">Simpan</button>
                          <div class="alert alert-danger" role="alert" v-if="update.form.alert != null">
                            {{update.form.alert}}
                          </div>
                          <div class="alert alert-success" role="alert" v-if="update.form.alertSuccess != null">
                            {{update.form.alertSuccess}}
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
      wa: ''
    })
    const update = {
      form : reactive({
        alert: null,
        alertSuccess: null
      }),
      submit() {
        var datax = new FormData();
        datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        datax.append('text', data.wa);
        datax.append('to', "wa");
        
        var apiUrl = inter.InfoTeksSimpan();
        myGlobal.call(datax,apiUrl).then(x => {

            //console.log(JSON.stringify(x));
            
            if (x.status == "true") {
                //data.datae = x.data;
                sessionStorage.setItem('wateks', data.wa);
                this.form.alertSuccess = "Info Telah diupdate";
                this.form.alert = null;
            } else {
                this.form.alert = x.pesan;
            }
        })
      }
    }
    return {
      data,
      myGlobal,
      update
    }
  },
  mounted () {
    document.title = "Update Profil";
    this.data.wa = sessionStorage.getItem("wateks");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/info-wa.vue